import React, { useState, useEffect } from 'react';
import Cookie from 'js-cookie';
import { BASE_URL } from '../../config/constants';
import { useTranslation } from 'react-i18next';
function AddAcademic() {
	const { t } = useTranslation();
	const [academicData, setAcademicData] = useState({
		name: '',
		facultyId: '',
	});
	const [academics, setAcademics] = useState([]);
	const [academicId, setAcademicId] = useState('');
	const [isEditing, setIsEditing] = useState(false);
	const [faculties, setFaculties] = useState([]);

	useEffect(() => {
		fetchAcademics();
		fetchFaculties();
	}, []);
	const baseUrl = BASE_URL; // Fetch all academic years
	const fetchAcademics = async () => {
		try {
			const response = await fetch(`${baseUrl}/api/academic-year`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${Cookie.get('token')}`,
				},
			});
			if (response.ok) {
				const data = await response.json();
				setAcademics(data);
			}
		} catch (error) {
			console.error(error);
		}
	};

	// Fetch all faculties for the dropdown
	const fetchFaculties = async () => {
		try {
			const response = await fetch(`${baseUrl}/api/faculty`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${Cookie.get('token')}`,
				},
			});
			if (response.ok) {
				const data = await response.json();
				setFaculties(data);
			}
		} catch (error) {
			console.error(error);
		}
	};

	// Handle input changes
	const handleInputsValue = (e) => {
		const { name, value } = e.target;
		setAcademicData({
			...academicData,
			[name]: value,
		});
	};

	// Handle form submission (Create or Update)
	const handleSubmitForm = async (e) => {
		e.preventDefault();

		try {
			const updatedAcademicData = {
				...academicData,
				facultyId: Number(academicData.facultyId), // Ensure facultyId is a number
			};

			const academicResponse = await fetch(
				isEditing
					? `${baseUrl}/api/academic-year/${academicId}`
					: `${baseUrl}/api/academic-year`,
				{
					method: isEditing ? 'PATCH' : 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${Cookie.get('token')}`,
					},
					body: JSON.stringify(updatedAcademicData),
				}
			);

			if (academicResponse.ok) {
				alert(
					isEditing
						? 'Academic year updated successfully'
						: 'Academic year added successfully'
				);
				setAcademicData({ name: '', facultyId: '' });
				setAcademicId('');
				setIsEditing(false);
				fetchAcademics();
			} else {
				alert('Error saving academic year data');
			}
		} catch (error) {
			alert('Error uploading form!');
			console.error(error);
		}
	};

	// Fetch academic year data for editing
	const handleGetAcademicData = async (event) => {
		const selectedAcademicId = event.target.value;
		setAcademicId(selectedAcademicId);

		try {
			const response = await fetch(
				`${baseUrl}/api/academic-year/${selectedAcademicId}`,
				{
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${Cookie.get('token')}`,
					},
				}
			);

			if (response.ok) {
				const data = await response.json();
				setAcademicData({
					name: data.name,
					facultyId: data.facultyId,
				});
				setIsEditing(true);
			}
		} catch (error) {
			console.error(error);
		}
	};

	// Handle academic year deletion
	const handleDeleteAcademic = async (event) => {
		event.preventDefault();
		if (!academicId) {
			alert('Please select an academic year to delete');
			return;
		}

		try {
			const response = await fetch(
				`${baseUrl}/api/academic-year/${academicId}`,
				{
					method: 'DELETE',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${Cookie.get('token')}`,
					},
				}
			);

			if (response.ok) {
				alert('Academic year deleted successfully');
				setAcademicId('');
				setAcademicData({ name: '', facultyId: '' });
				fetchAcademics();
			} else {
				alert('Error deleting academic year');
			}
		} catch (error) {
			alert('Error deleting academic year');
		}
	};

	return (
		<div className='flex justify-center gap-4 items-center flex-wrap container my-6 mt-36'>
			{/* Form for creating/editing academic years */}
			<form
				className='tagForm bg-white p-6 rounded-lg shadow-md w-full border-2 border-main flex flex-row flex-wrap gap-4 my-4'
				onSubmit={handleSubmitForm}>
				<h2 className='text-2xl text-main font-bold mb-4 w-full'>
					{isEditing ? 'Edit Academic Year' : 'Create Academic Year'}
				</h2>
				<div className='flex flex-col w-full md:w-1/3'>
					<label className='text-main'>{t('name')}</label>

					<input
						type='text'
						name='name'
						value={academicData.name}
						onChange={handleInputsValue}
						placeholder='Name'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>
				<div className='flex flex-col w-full md:w-1/3'>
					<label className='text-main'> {t('faculty')}</label>
					<select
						name='facultyId'
						value={academicData.facultyId}
						onChange={handleInputsValue}
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'>
						<option value=''>{t('selectFaculty')}</option>
						{faculties.map((faculty) => (
							<option
								key={faculty.id}
								value={faculty.id}>
								{faculty.name}
							</option>
						))}
					</select>
				</div>
				<button
					type='submit'
					className='w-auto bg-main text-white py-2 px-4 rounded-lg self-end'>
					{isEditing ? t('editAcademic') : t('createAcademic')}
				</button>
			</form>

			{/* Form for editing academic years */}
			<form className='bg-white p-6 rounded-lg shadow-md w-full border-2 border-main flex flex-wrap gap-3'>
				<h2 className='text-main text-2xl font-bold w-full'>
					{t('editAcademic')}
				</h2>
				<select
					className='block w-full text-sm text-gray-700 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none mb-4 p-2'
					value={academicId}
					onChange={handleGetAcademicData}>
					<option value=''>{t('selectEditAcademic')}</option>
					{academics.map((academic) => (
						<option
							key={academic.id}
							value={academic.id}>
							{academic.name}
						</option>
					))}
				</select>
			</form>

			{/* Form for deleting academic years */}
			<form
				className='bg-white p-6 rounded-lg shadow-md w-full border-2 border-red-600 flex flex-wrap gap-3'
				onSubmit={handleDeleteAcademic}>
				<h2 className='text-red-600 text-2xl font-bold w-full'>
					{t('deleteAcademic')}
				</h2>
				<select
					className='block w-full text-sm text-gray-700 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none mb-4 p-2'
					value={academicId}
					onChange={handleGetAcademicData}>
					<option value=''>{t('selectDeleteAcademic')}</option>
					{academics.map((academic) => (
						<option
							key={academic.id}
							value={academic.id}>
							{academic.name}
						</option>
					))}
				</select>
				<button
					type='submit'
					className='w-auto bg-red-600 text-white py-2 px-4 rounded-lg'>
					{t('deleteAcademic')}
				</button>
			</form>
		</div>
	);
}

export default AddAcademic;
